// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clipboard16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clipboard': IconClipboard;
    }
}

/**
 * The icon component for the 'clipboard' icon
 */
export class IconClipboard extends Icon {
    public constructor() {
        super(clipboard16X16);
    }
}

registerIcon('icon-clipboard', IconClipboard);
export const iconClipboardTag = 'nimble-icon-clipboard';
